import React from 'react';
import '../UnauthentifiedPages.scss';
import { Button, Container, Typography, Input, Spacing, Separator, Card } from '@design-system';
import { useLoginPageVM } from './useLoginPageVM';
import Logo from '@assets/images/logo/logo-cosem.svg?react';
import { Formik } from 'formik';
import { LoginRequest } from '@services/core/auth/auth.types';
import { useNavigate } from 'react-router-dom';
export const LoginPage: React.FC = () => {
    const { handleSubmit, isLoading } = useLoginPageVM();
    const navigate = useNavigate();

    return (
        <Container className="unauthentified-page">
            <Logo />
            <Spacing size="x-large" />
            <Separator fullWidth />
            <Spacing size="large" />
            <Typography intrinsic="p" className="welcome-back">
                Bienvenue à nouveau
            </Typography>
            <Spacing size="x-large" />
            <Typography intrinsic="h1">Connexion</Typography>
            <Spacing size="large" />
            <Card className='no-card login-card' isLoading={isLoading}>
            <Formik
                initialValues={{
                    email: '',
                    password: ''
                }}
                onSubmit={async (values: LoginRequest) => {
                    await handleSubmit(values);
                }}
            >
                {({ values, handleChange, handleSubmit }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <Input
                                label="Adresse e-mail"
                                placeholder="Adresse e-mail"
                                name="email"
                                value={values.email}
                                onChange={handleChange}
                            />
                            <Spacing size="small-medium" />
                            <Input
                                label="Mot de passe"
                                placeholder="Mot de passe"
                                name="password"
                                value={values.password}
                                onChange={handleChange}
                                type="password"
                            />
                            <Spacing size="x-small" />
                            <Typography
                                intrinsic="p"
                                variant="p2"
                                color="grey1"
                                className="forgot-password"
                                onClick={() => navigate('/forgot-password')}
                            >
                                Mot de passe oublié ?
                            </Typography>
                            <Spacing />
                            <Button variant="primary" disabled={isLoading}>
                                <Typography intrinsic="p">Se connecter</Typography>
                            </Button>
                        </form>
                    );
                }}
            </Formik>
            </Card>
        </Container>
    );
};
